import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
  <path d="M3-7A2,2,0,0,0,5-9a2,2,0,0,0-2-2A2,2,0,0,0,1-9,2,2,0,0,0,3-7ZM17-7a2,2,0,0,0,2-2,2,2,0,0,0-2-2,2,2,0,0,0-2,2A2,2,0,0,0,17-7Zm1,1H16a1.994,1.994,0,0,0-1.409.581A4.571,4.571,0,0,1,16.938-2H19a1,1,0,0,0,1-1V-4A2,2,0,0,0,18-6ZM10-6a3.5,3.5,0,0,0,3.5-3.5A3.5,3.5,0,0,0,10-13,3.5,3.5,0,0,0,6.5-9.5,3.5,3.5,0,0,0,10-6Zm2.4,1h-.259A4.923,4.923,0,0,1,10-4.5,4.933,4.933,0,0,1,7.859-5H7.6A3.6,3.6,0,0,0,4-1.4v.9A1.5,1.5,0,0,0,5.5,1h9A1.5,1.5,0,0,0,16-.5v-.9A3.6,3.6,0,0,0,12.4-5ZM5.409-5.419A1.994,1.994,0,0,0,4-6H2A2,2,0,0,0,0-4v1A1,1,0,0,0,1-2H3.059A4.583,4.583,0,0,1,5.409-5.419Z" transform="translate(0 13)" fill="#1d1d1d"/>
</svg>
  )
